import { WAGER_TYPE } from "./Bonus";

export enum AvailableTriggerCompaingStatusType {
  AVAILABLE = "available",
  AVAILABLE_QUEUE = "available_queue",
  UNAVAILABLE = "unavailable",
}

export type AvailableTriggerCompaingType = {
  id: number;
  status: AvailableTriggerCompaingStatusType;
  expireAt: string;
  name: string;
  textBeforeReceivingAward: string;
  textAfterReceivingAward: string;
  currency: string;
  amount: number;
  minAmount: number;
  wager: number;
  wagerType: WAGER_TYPE;
  wagerGameIds: string[];
  wagerProductNames: string[];
  wagerProviderNames: string[];
};

export type AvailableTriggerCompaingFreeSpinsType =
  AvailableTriggerCompaingType & {
    freeSpinsCount: number;
    freeSpinsGame: string;
  };
